/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL_RENTASSISTANT = new InjectionToken<string>('API_BASE_URL_RENTASSISTANT');

@Injectable()
export class RentAssistantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_RENTASSISTANT) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44397";
    }

    widget_SaveRealEstateObject(widgetParams: WidgetParams): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/api/Widget/saveRealEstateObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(widgetParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWidget_SaveRealEstateObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWidget_SaveRealEstateObject(<any>response_);
                } catch (e) {
                    return <Observable<PropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processWidget_SaveRealEstateObject(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PropertyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto>(<any>null);
    }

    widget_GetWidgetProperty(realEstateObjectId?: string | undefined): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/api/Widget/getWidgetProperty?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "realEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWidget_GetWidgetProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWidget_GetWidgetProperty(<any>response_);
                } catch (e) {
                    return <Observable<PropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processWidget_GetWidgetProperty(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PropertyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto>(<any>null);
    }

    widget_GetProfileScore(profile: ScoreProfileDto): Observable<CandidacyScore> {
        let url_ = this.baseUrl + "/api/Widget/GetProfileScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWidget_GetProfileScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWidget_GetProfileScore(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyScore>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyScore>><any>_observableThrow(response_);
        }));
    }

    protected processWidget_GetProfileScore(response: HttpResponseBase): Observable<CandidacyScore> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyScore>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CandidacyScore>(<any>null);
    }

    widget_GetProfileScoreForAnonymousProperty(profile: ScoreProfileOpenDto): Observable<CandidacyScore> {
        let url_ = this.baseUrl + "/api/Widget/GetProfileScoreForAnonymousProperty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWidget_GetProfileScoreForAnonymousProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWidget_GetProfileScoreForAnonymousProperty(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyScore>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyScore>><any>_observableThrow(response_);
        }));
    }

    protected processWidget_GetProfileScoreForAnonymousProperty(response: HttpResponseBase): Observable<CandidacyScore> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyScore>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CandidacyScore>(<any>null);
    }

    /**
     * Get a list of all Actions
     * @return A list of Action strings
     */
    actions_Get(): Observable<Action[]> {
        let url_ = this.baseUrl + "/candidacies/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActions_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActions_Get(<any>response_);
                } catch (e) {
                    return <Observable<Action[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Action[]>><any>_observableThrow(response_);
        }));
    }

    protected processActions_Get(response: HttpResponseBase): Observable<Action[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Action[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get a list of all available actions on a candidacy.
     * @param id The id of the candidacy to get the actions for.
     */
    actions_GetCandidacyActions(id: string): Observable<Action[]> {
        let url_ = this.baseUrl + "/candidacies/{id}/actions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActions_GetCandidacyActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActions_GetCandidacyActions(<any>response_);
                } catch (e) {
                    return <Observable<Action[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Action[]>><any>_observableThrow(response_);
        }));
    }

    protected processActions_GetCandidacyActions(response: HttpResponseBase): Observable<Action[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Action[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Performs an action on a candidacy.
     * @param id The id of the candidacy to take action on.
     * @param action Contains an action id and an optional comment.
     */
    candidacies_CandidacyAction(id: string, action: CandidacyActionDto): Observable<CandidacyDto> {
        let url_ = this.baseUrl + "/candidacies/{id}/actions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(action);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_CandidacyAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_CandidacyAction(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_CandidacyAction(response: HttpResponseBase): Observable<CandidacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    actions_SendEmail(emailDto: EmailDto): Observable<void> {
        let url_ = this.baseUrl + "/actions/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActions_SendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActions_SendEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActions_SendEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Gets a broker by it's organization number.
     * @param organizationNumber Broker organization number
     */
    brokers_Get(organizationNumber: string | null): Observable<BrokerDto> {
        let url_ = this.baseUrl + "/brokers/{organizationNumber}";
        if (organizationNumber === undefined || organizationNumber === null)
            throw new Error("The parameter 'organizationNumber' must be defined.");
        url_ = url_.replace("{organizationNumber}", encodeURIComponent("" + organizationNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBrokers_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBrokers_Get(<any>response_);
                } catch (e) {
                    return <Observable<BrokerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BrokerDto>><any>_observableThrow(response_);
        }));
    }

    protected processBrokers_Get(response: HttpResponseBase): Observable<BrokerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BrokerDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get a candidacy by it's unique id.
     * @param id Candidacy id
     * @param includeProfile (optional) true, to include the full profile associated with the candidacy
     * @return A candidacy with it's profile details
     */
    candidacies_GetCandidacy(id: string, includeProfile?: boolean | null | undefined): Observable<CandidacyDto> {
        let url_ = this.baseUrl + "/candidacies/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeProfile !== undefined && includeProfile !== null)
            url_ += "includeProfile=" + encodeURIComponent("" + includeProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_GetCandidacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_GetCandidacy(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_GetCandidacy(response: HttpResponseBase): Observable<CandidacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_GetCandidaciesForRealEstateObjectId(realEstateObjectId?: string | undefined, status?: Status | null | undefined, searchTerm?: string | null | undefined, candidacyOrderBy_SortOrder?: SortOrder | undefined, candidacyOrderBy_CandidacyOrderByEnum?: CandidacyOrderByEnum | undefined): Observable<CandidacyDto[]> {
        let url_ = this.baseUrl + "/candidaciesForRealEstateObjectId?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (candidacyOrderBy_SortOrder === null)
            throw new Error("The parameter 'candidacyOrderBy_SortOrder' cannot be null.");
        else if (candidacyOrderBy_SortOrder !== undefined)
            url_ += "CandidacyOrderBy.SortOrder=" + encodeURIComponent("" + candidacyOrderBy_SortOrder) + "&";
        if (candidacyOrderBy_CandidacyOrderByEnum === null)
            throw new Error("The parameter 'candidacyOrderBy_CandidacyOrderByEnum' cannot be null.");
        else if (candidacyOrderBy_CandidacyOrderByEnum !== undefined)
            url_ += "CandidacyOrderBy.CandidacyOrderByEnum=" + encodeURIComponent("" + candidacyOrderBy_CandidacyOrderByEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_GetCandidaciesForRealEstateObjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_GetCandidaciesForRealEstateObjectId(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_GetCandidaciesForRealEstateObjectId(response: HttpResponseBase): Observable<CandidacyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_GetCandidaciesForRealEstateObjectIdPaged(realEstateObjectId?: string | undefined, status?: Status | null | undefined, searchTerm?: string | null | undefined, candidacyOrderBy_SortOrder?: SortOrder | undefined, candidacyOrderBy_CandidacyOrderByEnum?: CandidacyOrderByEnum | undefined, index?: number | undefined, size?: number | undefined): Observable<PagedListOfCandidacyDto> {
        let url_ = this.baseUrl + "/candidaciesForRealEstateObjectIdPaged?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (candidacyOrderBy_SortOrder === null)
            throw new Error("The parameter 'candidacyOrderBy_SortOrder' cannot be null.");
        else if (candidacyOrderBy_SortOrder !== undefined)
            url_ += "CandidacyOrderBy.SortOrder=" + encodeURIComponent("" + candidacyOrderBy_SortOrder) + "&";
        if (candidacyOrderBy_CandidacyOrderByEnum === null)
            throw new Error("The parameter 'candidacyOrderBy_CandidacyOrderByEnum' cannot be null.");
        else if (candidacyOrderBy_CandidacyOrderByEnum !== undefined)
            url_ += "CandidacyOrderBy.CandidacyOrderByEnum=" + encodeURIComponent("" + candidacyOrderBy_CandidacyOrderByEnum) + "&";
        if (index === null)
            throw new Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "Index=" + encodeURIComponent("" + index) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_GetCandidaciesForRealEstateObjectIdPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_GetCandidaciesForRealEstateObjectIdPaged(<any>response_);
                } catch (e) {
                    return <Observable<PagedListOfCandidacyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedListOfCandidacyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_GetCandidaciesForRealEstateObjectIdPaged(response: HttpResponseBase): Observable<PagedListOfCandidacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedListOfCandidacyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_GetUnreadCandidaciesCount(): Observable<number> {
        let url_ = this.baseUrl + "/unreadCandidaciesCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_GetUnreadCandidaciesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_GetUnreadCandidaciesCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_GetUnreadCandidaciesCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_GetUnreadCandidacies(): Observable<CandidacyDto[]> {
        let url_ = this.baseUrl + "/unreadCandidacies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_GetUnreadCandidacies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_GetUnreadCandidacies(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_GetUnreadCandidacies(response: HttpResponseBase): Observable<CandidacyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_SetCandidacyRead(uniqueId: string): Observable<string> {
        let url_ = this.baseUrl + "/setCandidacyRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(uniqueId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_SetCandidacyRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_SetCandidacyRead(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_SetCandidacyRead(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_CreateCandidacyInternalComment(model: CandidacyInternalCommentCreateDto): Observable<CandidacyInternalCommentDto> {
        let url_ = this.baseUrl + "/createCandidacyInternalComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_CreateCandidacyInternalComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_CreateCandidacyInternalComment(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyInternalCommentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyInternalCommentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_CreateCandidacyInternalComment(response: HttpResponseBase): Observable<CandidacyInternalCommentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyInternalCommentDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get a paged list of all candidacies for a specific broker
     * @param realEstateObjectId (optional) The REDS id of the property
     * @param from (optional) 
     * @param to (optional) 
     * @param offset (optional) The offset used during paging
     * @param count (optional) The count used during paging
     * @return A paged result list of candidacies
     */
    candidacies_GetCandidaciesForBroker(realEstateObjectId?: string | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, offset?: number | undefined, count?: number | undefined): Observable<PagedListOfCandidacyForBrokerDto> {
        let url_ = this.baseUrl + "/broker/candidacies?";
        if (realEstateObjectId !== undefined && realEstateObjectId !== null)
            url_ += "realEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_GetCandidaciesForBroker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_GetCandidaciesForBroker(<any>response_);
                } catch (e) {
                    return <Observable<PagedListOfCandidacyForBrokerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedListOfCandidacyForBrokerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_GetCandidaciesForBroker(response: HttpResponseBase): Observable<PagedListOfCandidacyForBrokerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedListOfCandidacyForBrokerDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get a list of all candidacies of logged in user.
     * @return A list of CandidacyDto objects.
     */
    candidacies_GetMyCandidacies(): Observable<CandidacyDto[]> {
        let url_ = this.baseUrl + "/candidacies/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_GetMyCandidacies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_GetMyCandidacies(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_GetMyCandidacies(response: HttpResponseBase): Observable<CandidacyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Create a new candidacy for the logged in user.
     * @param newCandidacy Contains the broker's organization number and the property's reference id.
     * @return A Dto for the created Candidacy
     */
    candidacies_CreateCandidacy(newCandidacy: CreateCandidacyDto): Observable<CandidacyDto> {
        let url_ = this.baseUrl + "/candidacies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newCandidacy);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_CreateCandidacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_CreateCandidacy(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_CreateCandidacy(response: HttpResponseBase): Observable<CandidacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_UpdateBrokerComment(updateBrokerCommentDto: UpdateBrokerCommentDto): Observable<CandidacyDto> {
        let url_ = this.baseUrl + "/candidacies/updateBrokerComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateBrokerCommentDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_UpdateBrokerComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_UpdateBrokerComment(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_UpdateBrokerComment(response: HttpResponseBase): Observable<CandidacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_RejectAllForRealEstateObjectId(rejectAllDto: CandidacyRejectAllDto): Observable<CandidacyRejectResultDto> {
        let url_ = this.baseUrl + "/candidacies/rejectAllForRealEstateObjectId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rejectAllDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_RejectAllForRealEstateObjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_RejectAllForRealEstateObjectId(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyRejectResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyRejectResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_RejectAllForRealEstateObjectId(response: HttpResponseBase): Observable<CandidacyRejectResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyRejectResultDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CandidacyRejectResultDto>(<any>null);
    }

    candidacies_ArchiveCandidacy(candidacyArchive: CandidacyArchiveDto): Observable<CandidacyDto> {
        let url_ = this.baseUrl + "/candidacies/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(candidacyArchive);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_ArchiveCandidacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_ArchiveCandidacy(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_ArchiveCandidacy(response: HttpResponseBase): Observable<CandidacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    candidacies_GetScoreForCandidacy(id: string): Observable<CandidacyScore> {
        let url_ = this.baseUrl + "/candidacies/getResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidacies_GetScoreForCandidacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidacies_GetScoreForCandidacy(<any>response_);
                } catch (e) {
                    return <Observable<CandidacyScore>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidacyScore>><any>_observableThrow(response_);
        }));
    }

    protected processCandidacies_GetScoreForCandidacy(response: HttpResponseBase): Observable<CandidacyScore> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CandidacyScore>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CandidacyScore>(<any>null);
    }

    content_GetQuestionsAndAnswers(contentItemLanguage?: ContentItemLanguage | undefined): Observable<QuestionAndAnswerDto[]> {
        let url_ = this.baseUrl + "/content/qa?";
        if (contentItemLanguage === null)
            throw new Error("The parameter 'contentItemLanguage' cannot be null.");
        else if (contentItemLanguage !== undefined)
            url_ += "contentItemLanguage=" + encodeURIComponent("" + contentItemLanguage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContent_GetQuestionsAndAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContent_GetQuestionsAndAnswers(<any>response_);
                } catch (e) {
                    return <Observable<QuestionAndAnswerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionAndAnswerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processContent_GetQuestionsAndAnswers(response: HttpResponseBase): Observable<QuestionAndAnswerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <QuestionAndAnswerDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    content_GetWebTexts(contentItemLanguage?: ContentItemLanguage | undefined): Observable<WebTextDto[]> {
        let url_ = this.baseUrl + "/content/webtexts?";
        if (contentItemLanguage === null)
            throw new Error("The parameter 'contentItemLanguage' cannot be null.");
        else if (contentItemLanguage !== undefined)
            url_ += "contentItemLanguage=" + encodeURIComponent("" + contentItemLanguage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContent_GetWebTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContent_GetWebTexts(<any>response_);
                } catch (e) {
                    return <Observable<WebTextDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WebTextDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processContent_GetWebTexts(response: HttpResponseBase): Observable<WebTextDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WebTextDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get a list of all ErrorCodes
     * @return A list of ErrorCodeDtos.
     */
    errors_Get(): Observable<ErrorCodeDto[]> {
        let url_ = this.baseUrl + "/Errors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processErrors_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processErrors_Get(<any>response_);
                } catch (e) {
                    return <Observable<ErrorCodeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ErrorCodeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processErrors_Get(response: HttpResponseBase): Observable<ErrorCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ErrorCodeDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get an Organization by it's organization number.
     * @param organizationNumber (optional) The organization number as registered in the KBO.
     * @return An Organization with address and functions included
     */
    organizations_Get(organizationNumber?: string | null | undefined): Observable<OrganizationDto> {
        let url_ = this.baseUrl + "/organizations?";
        if (organizationNumber !== undefined && organizationNumber !== null)
            url_ += "organizationNumber=" + encodeURIComponent("" + organizationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrganizations_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrganizations_Get(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationDto>><any>_observableThrow(response_);
        }));
    }

    protected processOrganizations_Get(response: HttpResponseBase): Observable<OrganizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrganizationDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    owner_OwnerLogin(ownerLoginDto: OwnerLogin): Observable<OwnerLogin> {
        let url_ = this.baseUrl + "/api/Owner/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ownerLoginDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwner_OwnerLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwner_OwnerLogin(<any>response_);
                } catch (e) {
                    return <Observable<OwnerLogin>><any>_observableThrow(e);
                }
            } else
                return <Observable<OwnerLogin>><any>_observableThrow(response_);
        }));
    }

    protected processOwner_OwnerLogin(response: HttpResponseBase): Observable<OwnerLogin> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OwnerLogin>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OwnerLogin>(<any>null);
    }

    owner_GetOwnerShortlistDto(shortlistUniqueId?: string | undefined, phoneNumber?: string | null | undefined, token?: string | null | undefined, ownerSessionId?: string | null | undefined, loginStatus?: LoginStatus | null | undefined, sessionAvailableUntil?: Date | null | undefined): Observable<OwnerShortlistDto> {
        let url_ = this.baseUrl + "/api/Owner/shortlist?";
        if (shortlistUniqueId === null)
            throw new Error("The parameter 'shortlistUniqueId' cannot be null.");
        else if (shortlistUniqueId !== undefined)
            url_ += "ShortlistUniqueId=" + encodeURIComponent("" + shortlistUniqueId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (ownerSessionId !== undefined && ownerSessionId !== null)
            url_ += "OwnerSessionId=" + encodeURIComponent("" + ownerSessionId) + "&";
        if (loginStatus !== undefined && loginStatus !== null)
            url_ += "LoginStatus=" + encodeURIComponent("" + loginStatus) + "&";
        if (sessionAvailableUntil !== undefined && sessionAvailableUntil !== null)
            url_ += "SessionAvailableUntil=" + encodeURIComponent(sessionAvailableUntil ? "" + sessionAvailableUntil.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwner_GetOwnerShortlistDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwner_GetOwnerShortlistDto(<any>response_);
                } catch (e) {
                    return <Observable<OwnerShortlistDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OwnerShortlistDto>><any>_observableThrow(response_);
        }));
    }

    protected processOwner_GetOwnerShortlistDto(response: HttpResponseBase): Observable<OwnerShortlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OwnerShortlistDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OwnerShortlistDto>(<any>null);
    }

    owner_SaveOwnerPreference(ownerSavePreferenceDto: OwnerSavePreferenceDto): Observable<OwnerProfileDetailsDto[]> {
        let url_ = this.baseUrl + "/api/Owner/SavePreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ownerSavePreferenceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwner_SaveOwnerPreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwner_SaveOwnerPreference(<any>response_);
                } catch (e) {
                    return <Observable<OwnerProfileDetailsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OwnerProfileDetailsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processOwner_SaveOwnerPreference(response: HttpResponseBase): Observable<OwnerProfileDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OwnerProfileDetailsDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OwnerProfileDetailsDto[]>(<any>null);
    }

    owner_SubmitPreference(ownerSubmitPreferenceDto: OwnerSubmitPreferenceDto): Observable<OwnerShortlistDto> {
        let url_ = this.baseUrl + "/api/Owner/SubmitPreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ownerSubmitPreferenceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwner_SubmitPreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwner_SubmitPreference(<any>response_);
                } catch (e) {
                    return <Observable<OwnerShortlistDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OwnerShortlistDto>><any>_observableThrow(response_);
        }));
    }

    protected processOwner_SubmitPreference(response: HttpResponseBase): Observable<OwnerShortlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OwnerShortlistDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OwnerShortlistDto>(<any>null);
    }

    owner_GetShortlistsProperty(realEstateObjectId: string): Observable<ShortlistPropertyDto> {
        let url_ = this.baseUrl + "/api/Owner/getShortlistsProperty/{realEstateObjectId}";
        if (realEstateObjectId === undefined || realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' must be defined.");
        url_ = url_.replace("{realEstateObjectId}", encodeURIComponent("" + realEstateObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwner_GetShortlistsProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwner_GetShortlistsProperty(<any>response_);
                } catch (e) {
                    return <Observable<ShortlistPropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShortlistPropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processOwner_GetShortlistsProperty(response: HttpResponseBase): Observable<ShortlistPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShortlistPropertyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Add an attachment to the current user's draft profile
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @param originalFileName (optional) The original filename of the uploaded file
     * @param personId (optional) The person that receives the attachment
     * @param type (optional) The attachment type
     * @param profile (optional) The full profile
     * @return The updated profile, which now includes a reference to the document in the Oris document store
     */
    profilesAttachments_AddUserProfileAttachment(contentType?: string | null | undefined, contentDisposition?: string | null | undefined, headers?: IHeaderDictionary | null | undefined, length?: number | undefined, name?: string | null | undefined, fileName?: string | null | undefined, originalFileName?: string | null | undefined, personId?: number | undefined, type?: AttachmentType | undefined, profile?: ProfileDetailsDto | null | undefined): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/profiles/latest/attachments?";
        if (originalFileName !== undefined && originalFileName !== null)
            url_ += "originalFileName=" + encodeURIComponent("" + originalFileName) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (profile !== undefined && profile !== null)
            url_ += "profile=" + encodeURIComponent("" + profile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", headers.toString());
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfilesAttachments_AddUserProfileAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfilesAttachments_AddUserProfileAttachment(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfilesAttachments_AddUserProfileAttachment(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Delete an attachment from the current user's draft profile
     * @param profile The full profile
     * @param documentId (optional) The document store document id
     * @param personId (optional) The person to delete the attachment for
     */
    profilesAttachments_DeleteUserProfileAttachment(profile: ProfileDetailsDto, documentId?: string | undefined, personId?: number | undefined): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/profiles/latest/attachments?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfilesAttachments_DeleteUserProfileAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfilesAttachments_DeleteUserProfileAttachment(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfilesAttachments_DeleteUserProfileAttachment(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Add an attachment to the candidacy profile
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @param originalFileName (optional) The original filename of the uploaded file
     * @param personId (optional) The person that receives the attachment
     * @param type (optional) The attachment type
     * @param profile (optional) The full profile
     * @return The updated profile, which now includes the id of the document in the Oris document store
     */
    profilesAttachments_AddCandidacyProfileAttachment(candidacyId: string, contentType?: string | null | undefined, contentDisposition?: string | null | undefined, headers?: IHeaderDictionary | null | undefined, length?: number | undefined, name?: string | null | undefined, fileName?: string | null | undefined, originalFileName?: string | null | undefined, personId?: number | undefined, type?: AttachmentType | undefined, profile?: ProfileDetailsDto | null | undefined): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/candidacies/{candidacyId}/profiles/attachments?";
        if (candidacyId === undefined || candidacyId === null)
            throw new Error("The parameter 'candidacyId' must be defined.");
        url_ = url_.replace("{candidacyId}", encodeURIComponent("" + candidacyId));
        if (originalFileName !== undefined && originalFileName !== null)
            url_ += "originalFileName=" + encodeURIComponent("" + originalFileName) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (profile !== undefined && profile !== null)
            url_ += "profile=" + encodeURIComponent("" + profile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", headers.toString());
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfilesAttachments_AddCandidacyProfileAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfilesAttachments_AddCandidacyProfileAttachment(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfilesAttachments_AddCandidacyProfileAttachment(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Delete an attachment from the candidacy profile
     * @param candidacyId The unique Id of the candidacy
     * @param profile The full profile
     * @param documentId (optional) The document store document id
     * @param personId (optional) The person to delete the attachment for
     */
    profilesAttachments_DeleteCandidacyProfileAttachment(candidacyId: string, profile: ProfileDetailsDto, documentId?: string | undefined, personId?: number | undefined): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/candidacies/{candidacyId}/profiles/attachments?";
        if (candidacyId === undefined || candidacyId === null)
            throw new Error("The parameter 'candidacyId' must be defined.");
        url_ = url_.replace("{candidacyId}", encodeURIComponent("" + candidacyId));
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfilesAttachments_DeleteCandidacyProfileAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfilesAttachments_DeleteCandidacyProfileAttachment(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfilesAttachments_DeleteCandidacyProfileAttachment(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Download an attachment from the document store
     * @param documentId The document store document id
     * @return A stream containing the requested file
     */
    profilesAttachments_Download(documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/attachments/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfilesAttachments_Download(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfilesAttachments_Download(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProfilesAttachments_Download(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Download an attachment from the document store
     * @param documentId The document store document id
     * @return A stream containing the requested file
     */
    profilesAttachments_DownloadBase64(documentId: number): Observable<string> {
        let url_ = this.baseUrl + "/attachments/base64/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfilesAttachments_DownloadBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfilesAttachments_DownloadBase64(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processProfilesAttachments_DownloadBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get the latest profile for the current user
     * @return Profile details with completeness indication
     */
    profiles_GetUserProfile(): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/profiles/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfiles_GetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfiles_GetUserProfile(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfiles_GetUserProfile(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    profiles_GetUserProfileByFilter(searchTerm?: string | null | undefined, realEstateObjectId?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined): Observable<PagedListResultOfProfileDetailsDto> {
        let url_ = this.baseUrl + "/profiles/filter?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (realEstateObjectId !== undefined && realEstateObjectId !== null)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfiles_GetUserProfileByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfiles_GetUserProfileByFilter(<any>response_);
                } catch (e) {
                    return <Observable<PagedListResultOfProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedListResultOfProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfiles_GetUserProfileByFilter(response: HttpResponseBase): Observable<PagedListResultOfProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedListResultOfProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get the latest profile for the specified candidacy
     * @param candidacyId The id of the candidacy
     * @return Profile details with completeness indication
     */
    profiles_GetCandidacyProfile(candidacyId: string): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/candidacies/{candidacyId}/profiles/latest";
        if (candidacyId === undefined || candidacyId === null)
            throw new Error("The parameter 'candidacyId' must be defined.");
        url_ = url_.replace("{candidacyId}", encodeURIComponent("" + candidacyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfiles_GetCandidacyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfiles_GetCandidacyProfile(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfiles_GetCandidacyProfile(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Save a user's draft profile
     * @param profileDetailsDto The profile details
     * @return Profile details with completeness indication
     */
    profiles_SaveUserProfile(profileDetailsDto: ProfileDetailsDto): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/profiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileDetailsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfiles_SaveUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfiles_SaveUserProfile(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfiles_SaveUserProfile(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Save a profile for the specified candidacy
     * @param candidacyId The unique ID of the candidacy
     * @param profileDetailsDto The profile details
     * @return Profile details with completeness indication
     */
    profiles_SaveCandidacyProfile(candidacyId: string, profileDetailsDto: ProfileDetailsDto): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/candidacies/{candidacyId}/profiles";
        if (candidacyId === undefined || candidacyId === null)
            throw new Error("The parameter 'candidacyId' must be defined.");
        url_ = url_.replace("{candidacyId}", encodeURIComponent("" + candidacyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileDetailsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfiles_SaveCandidacyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfiles_SaveCandidacyProfile(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfiles_SaveCandidacyProfile(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Generates a public token for a profile. This can be a user (draft) profile or a candidacy profile.
     * @param candidacyId (optional) Optional unique id in the case of a candidacy profile
     * @return A public token that can be used to fetch a readonly version of the profile
     */
    profiles_GetPublicToken(candidacyId?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/profiles/latest/token?";
        if (candidacyId !== undefined && candidacyId !== null)
            url_ += "candidacyId=" + encodeURIComponent("" + candidacyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfiles_GetPublicToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfiles_GetPublicToken(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processProfiles_GetPublicToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    profiles_ShareLatestProfile(shareProfileDto: ShareProfileDto): Observable<ShareProfileCommand> {
        let url_ = this.baseUrl + "/profiles/shareLatestProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shareProfileDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfiles_ShareLatestProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfiles_ShareLatestProfile(<any>response_);
                } catch (e) {
                    return <Observable<ShareProfileCommand>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShareProfileCommand>><any>_observableThrow(response_);
        }));
    }

    protected processProfiles_ShareLatestProfile(response: HttpResponseBase): Observable<ShareProfileCommand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShareProfileCommand>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShareProfileCommand>(<any>null);
    }

    /**
     * Gets a property by it's reference.
     * @param realEstateObjectId Uniquely identifies a property
     */
    properties_Get(realEstateObjectId: string): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/properties/{realEstateObjectId}";
        if (realEstateObjectId === undefined || realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' must be defined.");
        url_ = url_.replace("{realEstateObjectId}", encodeURIComponent("" + realEstateObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_Get(<any>response_);
                } catch (e) {
                    return <Observable<PropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_Get(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PropertyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Gets a properties by it's filter.
     * @param searchTerm (optional) 
     * @param sortOrder (optional) 
     * @param propertiesOrderBy (optional) 
     * @param onlyPropertiesWithCandidacies (optional) 
     * @param hasExternalLink (optional) 
     * @param status (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     */
    properties_GetByFilter(searchTerm?: string | null | undefined, sortOrder?: SortOrder | null | undefined, propertiesOrderBy?: PropertiesOrderBy | null | undefined, onlyPropertiesWithCandidacies?: boolean | null | undefined, hasExternalLink?: boolean | null | undefined, status?: PropertyStatusDto[] | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined): Observable<PagedListResultOfPropertyDto> {
        let url_ = this.baseUrl + "/properties/filter?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (propertiesOrderBy !== undefined && propertiesOrderBy !== null)
            url_ += "PropertiesOrderBy=" + encodeURIComponent("" + propertiesOrderBy) + "&";
        if (onlyPropertiesWithCandidacies !== undefined && onlyPropertiesWithCandidacies !== null)
            url_ += "OnlyPropertiesWithCandidacies=" + encodeURIComponent("" + onlyPropertiesWithCandidacies) + "&";
        if (hasExternalLink !== undefined && hasExternalLink !== null)
            url_ += "HasExternalLink=" + encodeURIComponent("" + hasExternalLink) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_GetByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_GetByFilter(<any>response_);
                } catch (e) {
                    return <Observable<PagedListResultOfPropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedListResultOfPropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_GetByFilter(response: HttpResponseBase): Observable<PagedListResultOfPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedListResultOfPropertyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    properties_GetCandidacyInvitations(realEstateObjectId?: string | undefined, searchTerm?: string | null | undefined, sortOrder?: SortOrder | null | undefined, orderBy?: CandidacyInvitationOrderBy | null | undefined, onlyPropertiesWithCandidacies?: boolean | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined): Observable<PagedListResultOfCandidacyInvitationDto> {
        let url_ = this.baseUrl + "/properties/candidacyInvitations?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (onlyPropertiesWithCandidacies !== undefined && onlyPropertiesWithCandidacies !== null)
            url_ += "OnlyPropertiesWithCandidacies=" + encodeURIComponent("" + onlyPropertiesWithCandidacies) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_GetCandidacyInvitations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_GetCandidacyInvitations(<any>response_);
                } catch (e) {
                    return <Observable<PagedListResultOfCandidacyInvitationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedListResultOfCandidacyInvitationDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_GetCandidacyInvitations(response: HttpResponseBase): Observable<PagedListResultOfCandidacyInvitationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedListResultOfCandidacyInvitationDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    properties_GetFullLogForProperty(realEstateObjectId?: string | undefined, periodFrom?: Date | null | undefined, periodTo?: Date | null | undefined, userId?: string | null | undefined, logType?: LogType | null | undefined, logOrderBy?: LogOrderBy | null | undefined, orderByDescending?: boolean | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined): Observable<PagedListResultOfLogDto> {
        let url_ = this.baseUrl + "/properties/getFullLog?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (periodFrom !== undefined && periodFrom !== null)
            url_ += "PeriodFrom=" + encodeURIComponent(periodFrom ? "" + periodFrom.toJSON() : "") + "&";
        if (periodTo !== undefined && periodTo !== null)
            url_ += "PeriodTo=" + encodeURIComponent(periodTo ? "" + periodTo.toJSON() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (logType !== undefined && logType !== null)
            url_ += "LogType=" + encodeURIComponent("" + logType) + "&";
        if (logOrderBy !== undefined && logOrderBy !== null)
            url_ += "LogOrderBy=" + encodeURIComponent("" + logOrderBy) + "&";
        if (orderByDescending !== undefined && orderByDescending !== null)
            url_ += "OrderByDescending=" + encodeURIComponent("" + orderByDescending) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_GetFullLogForProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_GetFullLogForProperty(<any>response_);
                } catch (e) {
                    return <Observable<PagedListResultOfLogDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedListResultOfLogDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_GetFullLogForProperty(response: HttpResponseBase): Observable<PagedListResultOfLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedListResultOfLogDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    properties_LinkRealEstateObjectToRealSmartId(realEstateObjectRealSmartLink: RealEstateObjectRealSmartLinkDto): Observable<RealEstateObjectRealSmartLinkDto> {
        let url_ = this.baseUrl + "/properties/CreateRealSmartLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(realEstateObjectRealSmartLink);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_LinkRealEstateObjectToRealSmartId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_LinkRealEstateObjectToRealSmartId(<any>response_);
                } catch (e) {
                    return <Observable<RealEstateObjectRealSmartLinkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RealEstateObjectRealSmartLinkDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_LinkRealEstateObjectToRealSmartId(response: HttpResponseBase): Observable<RealEstateObjectRealSmartLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RealEstateObjectRealSmartLinkDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    properties_UpdateStatus(propertyStatusUpdateDto: PropertyStatusUpdateDto): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/properties/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyStatusUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_UpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_UpdateStatus(<any>response_);
                } catch (e) {
                    return <Observable<PropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_UpdateStatus(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PropertyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    properties_CreateProperty(manualPropertyDto: ManualPropertyDto): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/properties/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(manualPropertyDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_CreateProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_CreateProperty(<any>response_);
                } catch (e) {
                    return <Observable<PropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_CreateProperty(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PropertyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto>(<any>null);
    }

    properties_RemoveRealSmartLink(realEstateObjectIds: string[]): Observable<string[]> {
        let url_ = this.baseUrl + "/properties/RemoveRealSmartLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(realEstateObjectIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_RemoveRealSmartLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_RemoveRealSmartLink(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_RemoveRealSmartLink(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    properties_TransferProperty(propertyTransfer: PropertyTransferDto): Observable<PropertyTransferDto> {
        let url_ = this.baseUrl + "/properties/transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyTransfer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_TransferProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_TransferProperty(<any>response_);
                } catch (e) {
                    return <Observable<PropertyTransferDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PropertyTransferDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_TransferProperty(response: HttpResponseBase): Observable<PropertyTransferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PropertyTransferDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    properties_RemoveTransfer(realEsateObjectId: string[]): Observable<string[]> {
        let url_ = this.baseUrl + "/properties/removeTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(realEsateObjectId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_RemoveTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_RemoveTransfer(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_RemoveTransfer(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    properties_InviteForCandidacy(inviteForCandidacyDto: InviteForCandidacyDto): Observable<InviteForCandidacyDto> {
        let url_ = this.baseUrl + "/properties/inviteCandidacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inviteForCandidacyDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_InviteForCandidacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_InviteForCandidacy(<any>response_);
                } catch (e) {
                    return <Observable<InviteForCandidacyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InviteForCandidacyDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_InviteForCandidacy(response: HttpResponseBase): Observable<InviteForCandidacyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InviteForCandidacyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InviteForCandidacyDto>(<any>null);
    }

    properties_UpdateProperty(propertyRealSmartUpdateDto: PropertyRealSmartUpdateDto): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/properties/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyRealSmartUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperties_UpdateProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperties_UpdateProperty(<any>response_);
                } catch (e) {
                    return <Observable<PropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processProperties_UpdateProperty(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PropertyDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto>(<any>null);
    }

    shortlist_CreateShortlist(createShortlistDto: CreateShortlistDto): Observable<ShortlistDto> {
        let url_ = this.baseUrl + "/api/Shortlist/createShortlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createShortlistDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShortlist_CreateShortlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShortlist_CreateShortlist(<any>response_);
                } catch (e) {
                    return <Observable<ShortlistDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShortlistDto>><any>_observableThrow(response_);
        }));
    }

    protected processShortlist_CreateShortlist(response: HttpResponseBase): Observable<ShortlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShortlistDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    shortlist_GetShortlistByRealEstateId(realEstateObjectId: string): Observable<ShortlistDto[]> {
        let url_ = this.baseUrl + "/api/Shortlist/getShortlistsByRealEstateObjectId/{realEstateObjectId}";
        if (realEstateObjectId === undefined || realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' must be defined.");
        url_ = url_.replace("{realEstateObjectId}", encodeURIComponent("" + realEstateObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShortlist_GetShortlistByRealEstateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShortlist_GetShortlistByRealEstateId(<any>response_);
                } catch (e) {
                    return <Observable<ShortlistDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShortlistDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processShortlist_GetShortlistByRealEstateId(response: HttpResponseBase): Observable<ShortlistDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShortlistDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    shortlist_CancelShortlist(shortlistUniqueId: string): Observable<ShortlistDto> {
        let url_ = this.baseUrl + "/api/Shortlist/cancelShortlist/{shortlistUniqueId}";
        if (shortlistUniqueId === undefined || shortlistUniqueId === null)
            throw new Error("The parameter 'shortlistUniqueId' must be defined.");
        url_ = url_.replace("{shortlistUniqueId}", encodeURIComponent("" + shortlistUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShortlist_CancelShortlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShortlist_CancelShortlist(<any>response_);
                } catch (e) {
                    return <Observable<ShortlistDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShortlistDto>><any>_observableThrow(response_);
        }));
    }

    protected processShortlist_CancelShortlist(response: HttpResponseBase): Observable<ShortlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShortlistDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    shortlist_ExtendShortlist(extendShortlistDto: ExtendShortlistDto): Observable<ShortlistDto> {
        let url_ = this.baseUrl + "/api/Shortlist/extendShortlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(extendShortlistDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShortlist_ExtendShortlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShortlist_ExtendShortlist(<any>response_);
                } catch (e) {
                    return <Observable<ShortlistDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShortlistDto>><any>_observableThrow(response_);
        }));
    }

    protected processShortlist_ExtendShortlist(response: HttpResponseBase): Observable<ShortlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShortlistDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get a list of all candidacy  statuses
     * @return A list of Status strings.
     */
    statuses_Get(): Observable<string[]> {
        let url_ = this.baseUrl + "/candidacies/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatuses_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatuses_Get(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processStatuses_Get(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Get the profile corresponding to the given public token
     * @param token A token that matches a single profile
     * @return Profile details with metadata
     */
    tokens_GetProfileByToken(token: string | null): Observable<ProfileDetailsDto> {
        let url_ = this.baseUrl + "/tokens/{token}/profile";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokens_GetProfileByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokens_GetProfileByToken(<any>response_);
                } catch (e) {
                    return <Observable<ProfileDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfileDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processTokens_GetProfileByToken(response: HttpResponseBase): Observable<ProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProfileDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Returns the user details of the current logged in user.
     * @return Returns the logged in user details.
     */
    users_GetMe(): Observable<UserDto> {
        let url_ = this.baseUrl + "/Users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetMe(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUsers_GetMe(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    /**
     * Creates or updates the current logged in user in the database.
     * @param updateUser PrivacyStatementAccepted: Boolean to define if the user has accepted the privacy statement.
     * @return Returns the created or updated User details.
     */
    users_CreateOrUpdateUser(updateUser: UpdateCurrentUserDto): Observable<UserDto> {
        let url_ = this.baseUrl + "/Users/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateUser);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_CreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_CreateOrUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUsers_CreateOrUpdateUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    users_DeleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_DeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_DeleteUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUsers_DeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    users_GetUserProfileByFilter(searchTerm?: string | null | undefined, realEstateObjectId?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined): Observable<PagedListResultOfUserDto> {
        let url_ = this.baseUrl + "/Users/filter?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (realEstateObjectId !== undefined && realEstateObjectId !== null)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetUserProfileByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetUserProfileByFilter(<any>response_);
                } catch (e) {
                    return <Observable<PagedListResultOfUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedListResultOfUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUsers_GetUserProfileByFilter(response: HttpResponseBase): Observable<PagedListResultOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedListResultOfUserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    whitelistings_SaveWhitelisting(domains: DomainDto[]): Observable<DomainDto[]> {
        let url_ = this.baseUrl + "/api/Whitelistings/saveWhitelisting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(domains);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWhitelistings_SaveWhitelisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWhitelistings_SaveWhitelisting(<any>response_);
                } catch (e) {
                    return <Observable<DomainDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DomainDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processWhitelistings_SaveWhitelisting(response: HttpResponseBase): Observable<DomainDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DomainDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    whitelistings_GetWhitelistingForBroker(): Observable<DomainDto[]> {
        let url_ = this.baseUrl + "/api/Whitelistings/whitelisting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWhitelistings_GetWhitelistingForBroker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWhitelistings_GetWhitelistingForBroker(<any>response_);
                } catch (e) {
                    return <Observable<DomainDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DomainDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processWhitelistings_GetWhitelistingForBroker(response: HttpResponseBase): Observable<DomainDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DomainDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface PropertyDto {
    propertyType?: PropertyType | undefined;
    realEstateObjectId?: string;
    broker?: BrokerDto | undefined;
    imageUrl?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    postalCode?: string | undefined;
    box?: string | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    active?: boolean;
    name?: string | undefined;
    reference?: string | undefined;
    identifier?: string | undefined;
    candidaciesCount?: number | undefined;
    candidaciesToProcessCount?: number | undefined;
    lastActivityDate?: Date;
    realSmartLink?: string | undefined;
    sourceProperties?: PropertyDto[] | undefined;
    targetProperty?: PropertyDto | undefined;
    numberOfRooms?: number | undefined;
    numberOfBedrooms?: number | undefined;
    price?: number | undefined;
    monthlyExtraCosts?: number | undefined;
    createCandidacyUrl?: string | undefined;
    status?: PropertyStatusDto;
    additionalIdentifiers?: PropertyAdditionalIdentifierDto[] | undefined;
}

export enum PropertyType {
    House = "House",
    Apartment = "Apartment",
    Studio = "Studio",
}

export interface BrokerDto {
    id?: string;
    name?: string | undefined;
    logoUrl?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    companyIdentificationNumber?: string | undefined;
}

export enum PropertyStatusDto {
    Active = "Active",
    Archived = "Archived",
}

export interface PropertyAdditionalIdentifierDto {
    key?: string | undefined;
    value?: string | undefined;
}

export interface WidgetParams {
    url?: string | undefined;
    enterpriseNumber?: string | undefined;
    realEstateIdentifier?: string | undefined;
    uniqueIdentifier?: string | undefined;
    additionalWidgetParams?: AdditionalWidgetParams | undefined;
}

export interface AdditionalWidgetParams {
    realEstateIdentifiers?: AdditionalRealEstateIdentifiers[] | undefined;
}

export interface AdditionalRealEstateIdentifiers {
    key?: string | undefined;
    value?: string | undefined;
}

export interface CandidacyScore {
    residentialLoadPercentage?: number | undefined;
    hasEligibleTenantsCount?: boolean | undefined;
    aboveBudgetNormPercentage?: number | undefined;
    input?: ScoreProfileDto | undefined;
    budgetNorm?: number | undefined;
    monthlyIncomeAfterBudgedNorm?: number | undefined;
    rentalPrice?: number | undefined;
    maxTenantsForProperty?: number | undefined;
    numberOfBedrooms?: number | undefined;
}

export interface ScoreProfileDto {
    propertyUniqueId?: string;
    totalMonthlyIncome?: number | undefined;
    numberOfAdults?: number | undefined;
    numberOfChildren?: number | undefined;
    numberOfCars?: number | undefined;
    numberOfCambios?: number | undefined;
}

export interface ScoreProfileOpenDto {
    totalMonthlyIncome?: number | undefined;
    numberOfAdults?: number | undefined;
    numberOfChildren?: number | undefined;
    numberOfCars?: number | undefined;
    numberOfCambios?: number | undefined;
    property?: ScoreProfileProperty | undefined;
}

export interface ScoreProfileProperty {
    numberOfBedrooms?: number;
    propertyType?: PropertyType;
    price?: number;
    monthlyExtraCosts?: number | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export enum Action {
    Progress = "Progress",
    Recall = "Recall",
    Reject = "Reject",
    Approve = "Approve",
    Submit = "Submit",
    RequestInfo = "RequestInfo",
    Delete = "Delete",
    ContactBroker = "ContactBroker",
}

export interface EmailDto {
    fromName?: string | undefined;
    fromEmailAddress?: string | undefined;
    body?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface CandidacyDto {
    uniqueId?: string;
    status?: Status;
    statusComment?: string | undefined;
    isReadonly?: boolean;
    candidacyHistories?: CandidacyHistoryDto[] | undefined;
    statusChangedOn?: Date | undefined;
    submittedOn?: Date | undefined;
    broker?: BrokerDto | undefined;
    property?: PropertyDto | undefined;
    user?: UserDto | undefined;
    brokerComment?: string | undefined;
    language?: Language | undefined;
    isArchivedByUser?: boolean;
    internalComments?: CandidacyInternalCommentDto[] | undefined;
    profile?: ProfileDetailsDto | undefined;
    additionalBrokerInfo?: AdditionalBrokerInfoDto | undefined;
}

export enum Status {
    Draft = "Draft",
    InProgress = "InProgress",
    Recalled = "Recalled",
    Rejected = "Rejected",
    Approved = "Approved",
    Submitted = "Submitted",
    InfoRequested = "InfoRequested",
    Expired = "Expired",
}

export interface CandidacyHistoryDto {
    status?: Status;
    statusChangedOn?: Date;
    comment?: string | undefined;
    hasVisitedProperty?: boolean | undefined;
}

export interface UserDto {
    emailAddress?: string | undefined;
    ssoId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    privacyStatementAccepted?: boolean;
    languageCode?: string | undefined;
}

export enum Language {
    Dutch = "Dutch",
    English = "English",
    French = "French",
    German = "German",
}

export interface CandidacyInternalCommentDto {
    createdOn?: Date;
    comment?: string | undefined;
    createdBy?: string | undefined;
    createdByPersonId?: string;
    id?: string;
}

export interface ProfileDetailsDto {
    isReadonly?: boolean;
    userName?: string | undefined;
    generalDetails?: GeneralDetailsDto | undefined;
    personDetails?: PersonDetailsDto[] | undefined;
    profileAttachments?: ProfileAttachmentDto[] | undefined;
    profileComplete?: boolean;
}

export interface GeneralDetailsDto {
    numberOfAdults?: number | undefined;
    numberOfChildren?: number | undefined;
    numberOfPets?: number | undefined;
    petsDescription?: string | undefined;
    childrenDescription?: string | undefined;
    assistanceAnimal?: boolean | undefined;
    relocationType?: RelocationType | undefined;
    expectedMovingDate?: DateDto | undefined;
    durationPreference?: boolean | undefined;
    durationType?: DurationType | undefined;
    durationMonths?: number | undefined;
    durationYears?: number | undefined;
    willTakeDomicile?: boolean | undefined;
    isMainResidence?: boolean | undefined;
    isPartiallyProfessionalUse?: boolean | undefined;
    partiallyProfessionalComment?: string | undefined;
    hasAccessibilityNeeds?: boolean | undefined;
    accessibilityNeeds?: string | undefined;
    numberOfCars?: number | undefined;
    reasonForMoving?: string | undefined;
    generalDetailsMetaData?: GeneralDetailsMetadataDto | undefined;
}

export enum RelocationType {
    NoPreference = "NoPreference",
    SpecificDate = "SpecificDate",
    Asap = "Asap",
}

export interface DateDto {
    day?: number;
    month?: number;
    year?: number;
}

export enum DurationType {
    Max1Year = "Max1Year",
    Max3Years = "Max3Years",
    MoreThan3Years = "MoreThan3Years",
    Specific = "Specific",
}

export interface GeneralDetailsMetadataDto {
    residentsComplete?: boolean;
    relocationAndDurationComplete?: boolean;
    extraOptionsComplete?: boolean;
}

export interface PersonDetailsDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    identificationNumber?: string | undefined;
    hasPartner?: boolean | undefined;
    legalType?: PersonLegalType | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: AddressDto | undefined;
    monthlyIncome?: number | undefined;
    otherIncomes?: OtherIncome[] | undefined;
    hasCurrentRent?: boolean | undefined;
    landlordContactFilled?: boolean | undefined;
    landlordName?: string | undefined;
    landlordEmail?: string | undefined;
    landlordPhone?: string | undefined;
    organizationFoundInKbo?: boolean;
    organizationNumber?: string | undefined;
    organizationName?: string | undefined;
    organizationContactName?: string | undefined;
    organizationContactFunction?: string | undefined;
    organizationContactEmail?: string | undefined;
    organizationContactPhone?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
    personDetailsMetaData?: PersonDetailsMetaDataDto | undefined;
}

export enum PersonLegalType {
    Person = "Person",
    LegalEntity = "LegalEntity",
}

export interface AddressDto {
    street?: string | undefined;
    houseNumber?: string | undefined;
    zipCode?: string | undefined;
    place?: string | undefined;
    country?: string | undefined;
}

export interface OtherIncome {
    type?: OtherIncomeType;
    income?: number;
}

export enum OtherIncomeType {
    MealVouchers = "MealVouchers",
    ChildrensAllowance = "ChildrensAllowance",
    Alimony = "Alimony",
    Interest = "Interest",
    RentalPremium = "RentalPremium",
    Other = "Other",
}

export interface AttachmentDto {
    type?: AttachmentType;
    documentId?: number;
    fileName?: string | undefined;
}

export enum AttachmentType {
    ProofOfIncome = "ProofOfIncome",
    CompanyPublication = "CompanyPublication",
    BalanceSheet = "BalanceSheet",
    ProofOfOtherIncome = "ProofOfOtherIncome",
    Identification = "Identification",
    ProofOfPaymentOfRent = "ProofOfPaymentOfRent",
}

export interface PersonDetailsMetaDataDto {
    personalInfoComplete?: boolean;
    contactInfoComplete?: boolean;
    incomeInfoComplete?: boolean;
    currentLandlordInfoComplete?: boolean;
    organizationInfoComplete?: boolean;
    organizationAddressComplete?: boolean;
    organizationContactInfoComplete?: boolean;
    profileDetailsComplete?: boolean;
}

export interface ProfileAttachmentDto {
    uniqueId?: string;
    documentName?: string | undefined;
    personId?: number;
    attachmentType?: AttachmentType;
    documentStoreId?: number;
}

export interface AdditionalBrokerInfoDto {
    generalInfo?: string | undefined;
    accessibilityInfo?: string | undefined;
    tenantsInfo?: string | undefined;
    petsInfo?: string | undefined;
}

export enum SortOrder {
    Desc = "Desc",
    Asc = "Asc",
}

export enum CandidacyOrderByEnum {
    FirstName = "FirstName",
    LastName = "LastName",
    Email = "Email",
    Status = "Status",
    Date = "Date",
    Domicile = "Domicile",
    ProffesionalUse = "ProffesionalUse",
}

export interface PagedListOfCandidacyDto {
    data?: CandidacyDto[] | undefined;
    offset?: number;
    count?: number;
    totalCount?: number;
}

export interface CandidacyInternalCommentCreateDto {
    candidacyUniqueId?: string;
    comment?: string | undefined;
}

export interface PagedListOfCandidacyForBrokerDto {
    data?: CandidacyForBrokerDto[] | undefined;
    offset?: number;
    count?: number;
    totalCount?: number;
}

export interface CandidacyForBrokerDto {
    candidacyId?: string;
    status?: Status;
    statusChangedOn?: Date;
    submittedOn?: Date;
    submitComment?: string | undefined;
    brokerId?: string;
    realEstateObjectId?: string;
    tenantFirstName?: string | undefined;
    tenantLastName?: string | undefined;
    tenantEmail?: string | undefined;
    tenantsTotalIncome?: number;
    numberOfResidents?: number;
}

export interface CreateCandidacyDto {
    brokerOrganizationNumber?: string | undefined;
    realEstateObjectId?: string;
    commit?: boolean | undefined;
    mailLanguage?: Language | undefined;
}

export interface CandidacyActionDto {
    action?: Action;
    comment?: string | undefined;
    hasVisitedProperty?: boolean | undefined;
    language?: Language | undefined;
}

export interface UpdateBrokerCommentDto {
    brokerComment?: string | undefined;
    uniqueId?: string;
    additionalBrokerInfo?: AdditionalBrokerInfoDto | undefined;
}

export interface CandidacyRejectResultDto {
    candidacySuccessIds?: string[] | undefined;
    candidacyErrorIds?: string[] | undefined;
}

export interface CandidacyRejectAllDto {
    realEstateObjectId?: string;
    language?: Language | undefined;
    comment?: string | undefined;
}

export interface CandidacyArchiveDto {
    archive?: boolean;
    candidacyUniqueId?: string;
}

export interface ContentItemDto {
    id?: string;
    dateCreated?: Date;
    dateModified?: Date;
    status?: ContentItemStatus;
    language?: ContentItemLanguage;
}

export interface QuestionAndAnswerDto extends ContentItemDto {
    question?: string | undefined;
    category?: QaCategory;
    sortField?: string | undefined;
    answer?: string | undefined;
    image?: ContentItemImageDto | undefined;
}

export enum QaCategory {
    AanmeldenRegistreren = "AanmeldenRegistreren",
    Gebruik = "Gebruik",
    Algemeen = "Algemeen",
    Verhuurproces = "Verhuurproces",
    Tips = "Tips",
    Advies = "Advies",
    Makelaar = "Makelaar",
    Eigenaar = "Eigenaar",
}

export interface ContentItemImageDto {
    documentId?: number;
    name?: string | undefined;
    documentLink?: string | undefined;
}

export enum ContentItemStatus {
    Active = "Active",
    Concept = "Concept",
    Archived = "Archived",
    Deleted = "Deleted",
}

export enum ContentItemLanguage {
    Nl = "Nl",
    Fr = "Fr",
    De = "De",
    En = "En",
}

export interface WebTextDto extends ContentItemDto {
    title?: string | undefined;
    body?: string | undefined;
    image?: ContentItemImageDto | undefined;
}

export interface ErrorCodeDto {
    name?: string | undefined;
    code?: string;
}

export interface OrganizationDto {
    organizationNumber?: string | undefined;
    found?: boolean | undefined;
    active?: boolean | undefined;
    organizationName?: string | undefined;
    organizationCountry?: string | undefined;
    address?: OrganizationAddressDto | undefined;
    organizationLegalForm?: string | undefined;
    functions?: OrganizationFunctionDto[] | undefined;
}

export interface OrganizationAddressDto {
    street?: string | undefined;
    streetNumber?: string | undefined;
    streetBox?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryISOCode?: string | undefined;
}

export interface OrganizationFunctionDto {
    code?: string | undefined;
    description?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organizationNumber?: string | undefined;
}

export interface OwnerLogin {
    shortlistUniqueId?: string;
    phoneNumber?: string | undefined;
    token?: string | undefined;
    ownerSessionId?: string | undefined;
    loginStatus?: LoginStatus | undefined;
    sessionAvailableUntil?: Date | undefined;
}

export enum LoginStatus {
    Unknown = "Unknown",
    TokenSend = "TokenSend",
    SessionCreated = "SessionCreated",
    SessionExpired = "SessionExpired",
    Unauthorized = "Unauthorized",
    InvalidToken = "InvalidToken",
    AlreadySubmitted = "AlreadySubmitted",
    ShortlistExpired = "ShortlistExpired",
}

export interface OwnerShortlistDto {
    property?: PropertyDto | undefined;
    broker?: BrokerDto | undefined;
    profileDetails?: OwnerProfileDetailsDto[] | undefined;
}

export interface OwnerProfileDetailsDto {
    candidacyId?: number;
    preferenceOrder?: number | undefined;
    additionalBrokerInfo?: AdditionalBrokerInfoDto | undefined;
    generalDetails?: OwnerGeneralDetailsDto | undefined;
    personDetails?: OwnerPersonDetailsDto[] | undefined;
}

export interface OwnerGeneralDetailsDto {
    numberOfAdults?: number | undefined;
    numberOfChildren?: number | undefined;
    numberOfPets?: number | undefined;
    petsDescription?: string | undefined;
    childrenDescription?: string | undefined;
    assistanceAnimal?: boolean | undefined;
    relocationType?: RelocationType | undefined;
    expectedMovingDate?: DateDto | undefined;
    durationPreference?: boolean | undefined;
    durationType?: DurationType | undefined;
    durationMonths?: number | undefined;
    durationYears?: number | undefined;
    willTakeDomicile?: boolean | undefined;
    isPartiallyProfessionalUse?: boolean | undefined;
    hasAccessibilityNeeds?: boolean | undefined;
    reasonForMoving?: string | undefined;
}

export interface OwnerPersonDetailsDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    legalType?: PersonLegalType | undefined;
    email?: string | undefined;
    address?: AddressDto | undefined;
    monthlyIncome?: number | undefined;
    otherIncomes?: OtherIncome[] | undefined;
    hasCurrentRent?: boolean | undefined;
    organizationFoundInKbo?: boolean;
    organizationNumber?: string | undefined;
    organizationName?: string | undefined;
    organizationContactName?: string | undefined;
    organizationContactFunction?: string | undefined;
    organizationContactEmail?: string | undefined;
    organizationContactPhone?: string | undefined;
}

export interface OwnerSavePreferenceDto {
    ownerProfilePreference?: OwnerProfilePreference[] | undefined;
    ownerLogin?: OwnerLogin | undefined;
}

export interface OwnerProfilePreference {
    candidacyId?: number;
    preferenceOrder?: number | undefined;
}

export interface OwnerSubmitPreferenceDto {
    ownerLogin?: OwnerLogin | undefined;
    executedComment?: string | undefined;
    hasApproved?: boolean;
}

export interface ShortlistPropertyDto {
    property?: PropertyDto | undefined;
    broker?: BrokerDto | undefined;
}

export interface IHeaderDictionary {
    item?: string[];
    contentLength?: number | undefined;
}

export interface PagedListResultOfProfileDetailsDto {
    values?: ProfileDetailsDto[] | undefined;
    unpagedCount?: number;
    pageIndex?: number;
    pageSize?: number;
}

export interface ShareProfileCommand {
    shareProfile?: ShareProfileDto | undefined;
}

export interface ShareProfileDto {
    email?: string | undefined;
}

export interface PagedListResultOfPropertyDto {
    values?: PropertyDto[] | undefined;
    unpagedCount?: number;
    pageIndex?: number;
    pageSize?: number;
}

export enum PropertiesOrderBy {
    Address = "Address",
    RealSmartLink = "RealSmartLink",
    CandidaciesCount = "CandidaciesCount",
    LastActivity = "LastActivity",
    Status = "Status",
}

export interface PagedListResultOfCandidacyInvitationDto {
    values?: CandidacyInvitationDto[] | undefined;
    unpagedCount?: number;
    pageIndex?: number;
    pageSize?: number;
}

export interface CandidacyInvitationDto {
    email?: string | undefined;
    message?: string | undefined;
    createdByPersonId?: string;
    realEstateObjectId?: string;
    createdByPerson?: string | undefined;
    createdOn?: Date;
    language?: Language | undefined;
    subject?: string | undefined;
}

export enum CandidacyInvitationOrderBy {
    Email = "Email",
    Date = "Date",
}

export interface PagedListResultOfLogDto {
    values?: LogDto[] | undefined;
    unpagedCount?: number;
    pageIndex?: number;
    pageSize?: number;
}

export interface LogDto {
    dateOccured?: Date;
    userId?: string;
    logType?: LogType;
    message?: string | undefined;
}

export enum LogType {
    CandidacyStatusChange = "CandidacyStatusChange",
    RealSmartLinkChange = "RealSmartLinkChange",
    ShortListChange = "ShortListChange",
    PropertyTransferChange = "PropertyTransferChange",
}

export enum LogOrderBy {
    Date = "Date",
    LogType = "LogType",
    UserId = "UserId",
}

export interface RealEstateObjectRealSmartLinkDto {
    realEstateObjectId?: string;
    externalRealSmartLinkId?: string | undefined;
}

export interface PropertyStatusUpdateDto {
    propertyId?: string;
    status?: PropertyStatusDto;
}

export interface ManualPropertyDto {
    name?: string | undefined;
    numberOfRooms?: number;
    numberOfBedrooms?: number;
    petsAllowed?: boolean;
    reference?: string | undefined;
    identifier?: string | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    price?: number;
    monthlyExtraCosts?: number;
    streetAddress?: string | undefined;
    streetNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    manualPropertyType?: ManualPropertyTypeEnum;
}

export enum ManualPropertyTypeEnum {
    House = "House",
    Apartment = "Apartment",
    Studio = "Studio",
}

export interface PropertyTransferDto {
    targetPropertyId?: string;
    sourcePropertyId?: string[] | undefined;
}

export interface InviteForCandidacyDto {
    propertyId?: string;
    email?: string | undefined;
    message?: string | undefined;
    language?: Language;
}

export interface PropertyRealSmartUpdateDto {
    numberOfRooms?: number | undefined;
    numberOfBedrooms?: number | undefined;
    monthlyExtraCosts?: number | undefined;
    price?: number | undefined;
    active?: boolean | undefined;
    propertyType?: PropertyType | undefined;
    realEstateObjectId?: string;
}

export interface ShortlistDto {
    shortlistCandidacies?: ShortlistCandidacyDto[] | undefined;
    uniqueId?: string | undefined;
    status?: ShortListStatus;
    executedOn?: Date | undefined;
    executedComment?: string | undefined;
    hasApproved?: boolean | undefined;
    message?: string | undefined;
    subject?: string | undefined;
    url?: string | undefined;
    expiryDate?: Date;
    createdOn?: Date;
    contactInfo?: ContactDto | undefined;
}

export interface ShortlistCandidacyDto {
    uniqueId?: string | undefined;
    candidacyUniqueId?: string;
    preferenceOrder?: number | undefined;
    user?: CandidacyUserDto | undefined;
    brokerComment?: string | undefined;
    status?: Status;
    willTakeDomicile?: boolean | undefined;
    isPartiallyProfessionalUse?: boolean | undefined;
    createdOn?: Date;
}

export interface CandidacyUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export enum ShortListStatus {
    Draft = "Draft",
    InProgress = "InProgress",
    Submitted = "Submitted",
    Expired = "Expired",
    Created = "Created",
    Cancelled = "Cancelled",
}

export interface ContactDto {
    phoneNumber?: string | undefined;
    email?: string | undefined;
    language?: Language | undefined;
}

export interface CreateShortlistDto {
    realEstateObjectId?: string;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    subject?: string | undefined;
    language?: Language;
}

export interface ExtendShortlistDto {
    uniqueId?: string;
    daysToExtend?: number;
}

export interface UpdateCurrentUserDto {
    privacyStatementAccepted?: boolean;
    languageTwoLetterIsoCode?: string | undefined;
}

export interface PagedListResultOfUserDto {
    values?: UserDto[] | undefined;
    unpagedCount?: number;
    pageIndex?: number;
    pageSize?: number;
}

export interface DomainDto {
    hostUrl?: string | undefined;
    uniqueId?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}